import React from 'react'
import { DeleteOutlined, EditOutlined } from '@material-ui/icons'
import styled from 'styled-components'

export default (edit, confirmRemove) => (commandCellProps) => {
    return (
        <Section>
            <EditOutlined onClick={() => {edit(commandCellProps.dataItem)}} style={{ cursor: 'pointer' }}/>
            &nbsp;
            <DeleteOutlined onClick={() => {confirmRemove(commandCellProps.dataItem)}} style={{ cursor: 'pointer' }}/>
        </Section>
    )
}

const Section = styled.td`
    display: flex;
    height: 33px;
    align-items: center;
    justify-content: space-around;
`



// WEBPACK FOOTER //
// ./src/components/dialog/BaseDataGridCommandCell.js